/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/


export default {
  ADD_ITEM (state, user) {
    state.companies.push(Object.assign({}, user))
  },
  SET_COMPANIES (state, companies) {
    state.companies = companies
  },
  REMOVE_RECORD (state, itemId) {
    const companyIndex = state.companies.findIndex((u) => u.id === itemId)
    state.companies.splice(companyIndex, 1)
  }
}
